export const SET_USER = 'SET_USER';
export const SET_USER_TIMEZONE = 'SET_USER_TIMEZONE';
export const SET_USER_ID_TOKEN_RESULT = 'SET_USER_ID_TOKEN_RESULT';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER_PROFILE_UNSUBSCRIBE_FN = 'SET_USER_PROFILE_UNSUBSCRIBE_FN';
export const SET_ACCOUNT_VIEW_VISIBILITY = 'SET_ACCOUNT_VIEW_VISIBILITY';
export const SET_ONBOARDING_VISIBILITY = 'SET_ONBOARDING_VISIBILITY';
